import script from "./filterBar.vue?vue&type=script&setup=true&lang=js"
export * from "./filterBar.vue?vue&type=script&setup=true&lang=js"

import "./filterBar.vue?vue&type=style&index=0&id=edc3d6a4&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edc3d6a4"]])

export default __exports__